import { render } from "./InstallSigner.vue?vue&type=template&id=984ceff0"
const script = {}

import exportComponent from "D:\\git\\tim\\tim-sign-ui_imza.ebirlik.net\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__